export default __webpack_public_path__ + "static/media/phone.4006fe22.png";